// Financials tab redesign — query-key factory for the loan's Phoenix Income
// Pools booked-ledger reads. Array-literal query keys live ONLY in *Keys.ts
// files (stale-after-save convention); the hooks in useIncomePools import this.

export const incomePoolsKeys = {
  loan: (loanId: string) =>
    ["portfolio-admin", "loan", loanId, "income-pools"] as const,
  periodEvents: (loanId: string, periodStart: string) =>
    ["portfolio-admin", "loan", loanId, "income-pools", "events", periodStart] as const,
};
